import React from 'react'
import { twMerge } from 'tailwind-merge'

interface Select {
    id: string,
    label: string,
    options: { [key: string]: any }[],
    error?: string,
    containerClassProps?: string,
    [key: string]: any
}

const Select: React.FC<Select> = ({ id, label, options, error, containerClassProps, ...props }) => {
  // Classes para estilização do container
  const SubContainerStyle = 'px-2 py-1 bg-neutro-50 rounded-sm border'

  // Função para lidar com estado de erro do select (Estilização do container)
  const SubContainerErrorState = (): string => { return error && !props.disabled ? "outline outline-erro-500" : "" }
  const SubContainerFinalStyle = twMerge(SubContainerStyle, SubContainerErrorState())

  // Classes para estilização do label
  const LabelStyle = 'block text-primario-700 font-medium'
  
  // Função para lidar com estado de erro do select
  const SelectDisabledState = (): string => { return props.disabled ? 'text-neutro-200 cursor-not-allowed' : '' }
  const SelectFinalStyle = twMerge('w-full py-1 outline-none', SelectDisabledState())

  const LabelDisabledState = (): string => { return props.disabled ? "text-neutro-200" : "text-primario-700" }
  const LabelErrorState = (): string => { return error && !props.disabled ? "text-erro-500" : "" }

  const LabelFinalStyle = twMerge(LabelStyle, LabelDisabledState(), LabelErrorState())

  return (
    <div className={containerClassProps}>
      <label className={LabelFinalStyle} htmlFor={id}>{label}</label>
      <div className={SubContainerFinalStyle}>
          <select className={SelectFinalStyle} name={id} id={id} {...props}>
            { props.placeholder && <option value="" disabled>{props.placeholder}</option> }
            {options.map(((option, index) => (
              <option value={option.value} key={index}>{option.title}</option>
            )))}
          </select>
      </div>
      { error && !props.disabled && <p className='text-erro-500 mt-1'>{error}</p> }
    </div>
  )
}

export default Select